import React, { Component } from "react"
import PropTypes from "prop-types"

import { withAuth } from "../components/Auth"
import Heading from "../components/Heading"
import Layout from "../components/Layout/Layout"
import { SubscribeForm } from "../components/Subscriptions"


export class AccountPage extends Component {
  renderIntro() {
    return (
      <>
        <Heading level={1} modifiers={["major"]}>Pricing Plans & Options</Heading>

        <p>
            <i>Make sure to subscribe with your own account to access
            premium features, provide your cloud credentials and deploy in your own cloud accounts.</i>
        </p>
      </>
    )
  }

  

  render() {
    return (
      <Layout showClouds>
        <div className="card">
          {this.renderIntro()}
        </div>
        <SubscribeForm/>
      </Layout>
    )
  }
}

AccountPage.propTypes = {
  user: PropTypes.object
}

export default withAuth(AccountPage)
